import { ReactComponent as PxLoading } from "../../img/prescription_loading.svg";
import { useTranslation } from "react-i18next";
import PrescriptionView from "./prescriptionView";
import MedicinePx from "./medicinePx";
import createPersistedState from "use-persisted-state";
import PxPDFView from "./PxPDFViewVer2";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { getModel } from "./PxPDFModel";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Grid, TextField, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { BlobProvider } from "@react-pdf/renderer";
import { Assessment } from "@material-ui/icons";

const useProfileState = createPersistedState("profile");
const useTokenState = createPersistedState("token");

const dummyPrescription = {
  status: {
    success: true,
    code: 200,
    message: null,
  },
  prescription: {
    id: 1,
    date: "2023-01-07",
    medicines: [
      {
        drugName: "Tablet Atorva",
        drugType: null, // Not used?
        strength: "650MG", // Where to render
        frequency: [0, 0, 1],
        frequencyPerWeek: 2, // Not used? Understand this prop better
        duration: "1 Month", // Not used?
        instruction: "",
      },
      {
        drugName: "Tablet Folitrax",
        drugType: null,
        strength: "650MG",
        frequency: [0, 1, 0],
        frequencyPerWeek: 2,
        duration: "1 Month",
        instruction: "Only on Monday",
      },
      {
        drugName: "Capsule Uprise",
        drugType: null,
        strength: "650MG",
        frequency: [1, 0, 0],
        frequencyPerWeek: 2,
        duration: "1 Month",
        instruction: "Once in a Month",
      },
    ],
    advices: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.", // Not used?
    instructions: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    bodyScans: ["CT", "MRI"],
    pathologies: ["CBC", "FBS"],
    followUpDate: "2023-02-05",
  },
  history: [],
};

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: "#f6781b",
    textAlign: "center",
    color: "#FFFFFF",
    margin: 20,
    flex: 1,
    width: "50% ",
    "&:hover": {
      backgroundColor: "#f6781b",
      textAlign: "center",
      color: "#FFFFFF",
      margin: 20,
      flex: 1,
      width: "50% ",
    },
  },
  TextField: {
    padding: 10,
  },
  emptyStateText: {
    textAlign: "center",
    color: "#f78f2d",
  },
}));

const LatestPx = ({
  isLoading,
  patientPx,
  shouldBookAppointment,
  complaints,
  assessmentScoresSentence,
  findingsSentence,
}) => {
  const [profile, _] = useProfileState();
  const [token, __] = useTokenState();
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => {
    setShowModal(false);
  };
  const [email, setEmail] = useState("");
  const classes = useStyles();

  useEffect(() => {
    profile?.email && setEmail(profile.email);
  }, [profile]);

  function sendToMail(blob) {
    var base64String;
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      base64String = reader.result;
      base64String = base64String.replace("data:application/pdf;base64,", "");
      console.log("pat", patientPx);
      fetch("/api/v1/utility/send/prescription", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          email: email,
          prescriptionId: patientPx?.prescription?.id,
          base64Pdf: base64String,
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {
          if (responseData["status"]["success"]) {
            handleClose();
          } else {
            // handle error
          }
        })
        .catch((err) => {
          console.log("Somethign went wrong");
        });
    };
  }

  const loadingView = () => (
    <div id="loading_content" className="loading_content text-center py-3">
      <p className="desc" style={{ textAlign: "center", margin: "auto" }}>
        {t("px.fetchingLatestPxMsg1")}
      </p>
      <p className="desc" style={{ textAlign: "center", margin: "auto" }}>
        {t("px.fetchingLatestPxMsg2")}
      </p>
      <div className="thumbnail" style={{ marginTop: "5em" }}>
        <PxLoading className="img-fluid" />
      </div>
    </div>
  );

  const PxNotAvailable = () => (
    <>
      <div className=" text-center py-3 px-3">
        <span
          className={classes.emptyStateText}
          style={{ textAlign: "center", margin: "auto" }}
        >
          {shouldBookAppointment ? (
            <>{t("px.pxUnavailable")}</>
          ) : (
            <>{t("px.pxFetchError")}</>
          )}
        </span>
      </div>
    </>
  );

  /*
   * Queries:
   * Is next appointment recommendation always present?
   *
   * TODO:
   * Format follow up date according to UI/UX
   * Tab headers should be sticky for prescription and reports page
   * Review how failure / edge cases are handled
   */
  const pxView = (px) => {
    return px ? (
      <>
        <div
          className="body_content px_scroll_view"
          style={{ marginTop: "1em" }}
        >
          <div className="inner_body">
            <div id="test_content" className="animate-bottom">
              <div className="content_presc_row py-2">
                <h3 className="maintitle">{t("px.medicineHeader")}</h3>
                <div className="inner_presc">
                  <MedicinePx medicines={px.medicines} />
                </div>
              </div>
              <PrescriptionView px={px} />
              <div className="bottom_button bottom_button_shadow mt-3 btn_block d-flex align-items-center justify-content-center">
                {profile && px && (
                  <>
                    <button
                      className="btn btn_outline"
                      style={{ height: "35px" }}
                      onClick={() => setShowModal(true)}
                    >
                      Send to mail
                    </button>

                    <PDFDownloadLink
                      className="btn btn_outline"
                      style={{ height: "35px", paddingTop: "0.2em" }}
                      document={
                        <PxPDFView
                          pxInfo={getModel(
                            profile,
                            px,
                            complaints,
                            assessmentScoresSentence,
                            findingsSentence
                          )}
                          profile={profile}
                          clinic={px?.clinicMetadata}
                          lang={profile?.language || "en-GB"}
                        />
                      }
                      fileName="prescription.pdf"
                    >
                      {({ blob, url, loading, error }) =>
                        loading ? "Loading document..." : "Download"
                      }
                    </PDFDownloadLink>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <Modal show={showModal} onHide={handleClose} className="custom_modal">
          <Modal.Header>
            Send Prescription to mail
            <CloseIcon onClick={handleClose} />
          </Modal.Header>
          <Modal.Body>
            {/* <form noValidate autoComplete="off"> */}
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <TextField
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                fullWidth
                // variant="contained"
                className={classes.TextField}
              />

              <BlobProvider
                className="btn btn_outline"
                style={{ height: "35px", paddingTop: "0.2em" }}
                document={
                  <PxPDFView
                    pxInfo={getModel(
                      profile,
                      px,
                      complaints,
                      assessmentScoresSentence,
                      findingsSentence
                    )}
                    profile={profile}
                    clinic={px?.clinicMetadata}
                    lang={profile?.language || "en-GB"}
                  />
                }
              >
                {({ blob, url, loading, error }) => {
                  return (
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      onClick={() => {
                        sendToMail(blob);
                      }}
                    >
                      Send to mail
                    </Button>
                  );
                }}
              </BlobProvider>
            </Grid>
            {/* </form> */}
          </Modal.Body>
        </Modal>
      </>
    ) : (
      <PxNotAvailable />
    );
  };

  return (
    <>
      <div id="lastestpx">
        {isLoading ? loadingView() : pxView(patientPx?.prescription)}
      </div>
    </>
  );
};

export default LatestPx;
